import { redactShareTokens } from '@/lib/observability/share-url-redaction';

/**
 * beforeSend for Vercel Analytics and Speed Insights (sharing review r7 #1):
 * the same share-token redaction PostHog uses (share-url-redaction.ts), so
 * no `/share/apps/<token>` (raw or inside an encoded return target) leaves
 * the browser in their URLs.
 */

export function vercelAnalyticsBeforeSend<T extends { url: string }>(
  event: T
): T | null {
  return { ...event, url: redactShareTokens(event.url) };
}

export function speedInsightsBeforeSend<
  T extends { url: string; route?: string },
>(event: T): T | null {
  return {
    ...event,
    url: redactShareTokens(event.url),
    ...(event.route !== undefined
      ? { route: redactShareTokens(event.route) }
      : {}),
  };
}
